import Vue from 'vue';

import SalesGrid from '@components/sales-item/script.js';

let PageComponent = {
  name: 'sales',
  data() {
    return {
      template: '<p>default temp</p>',
    };
  },
  components: {
    'sales-cmp': SalesGrid,
  },
  methods: {
    setTemplate(template) {
      this.template = template.data;
    },
    setData(data, to) {
      this.setTemplate(data);
    },
  },
  beforeRouteUpdate(to, from, next) {
    next();
  },
  beforeRouteEnter(to, from, next) {
    let products = document.querySelector('#sales');
    if (products) {
      products.remove();
    }

    let url = '/api/templates/sales';
    Vue.http.get(url, { params: to.query }).then((data) => {
      next((vm) => vm.setData(data));
    });
  },
  render(createElement) {
    return Vue.compile(this.template).render.call(this, createElement);
  },
};
export default PageComponent;



// WEBPACK FOOTER //
// ./src/templates/pages/sales/index.js